import styled from "@emotion/styled";

export const ToggleButtonWrapper = styled.div`
  text-align: center;
  padding: 0px 10px;
  width: 100%;
`;

export const ToggleGroupContainer = styled.div<{
  variant: "primary" | "secondary";
}>`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: ${({ variant }) =>
    variant === "primary" ? `0.4375rem 0.3125rem` : ``};
  border: 0.0625rem solid
    ${({ variant }) => (variant === "primary" ? `#f4f4f4` : `#fff`)};
  border-radius: 0.875rem;
  overflow: hidden;
  background-color: ${({ variant }) =>
    variant === "primary" ? "#f4f4f4" : "white"};
`;

export const ToggleButton = styled.button<{
  size: any;
  variant: "primary" | "secondary";
  position?: "left" | "middle" | "right";
}>`
  border: none;
  padding: ${({ variant }) =>
    variant === "primary" ? "0.625rem 1.5625rem" : "1.1rem 1rem"};
  border-radius: 0.75rem;
  background: none;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  color: grey;
  font-size: 0.875rem;
  white-space: nowrap;

  /* Position-specific styles */
  ${({ position }) =>
    position === "left"
      ? `
      justify-self: start;
      margin-left: 0.125rem;
      margin-right: auto;
    `
      : position === "right"
      ? `
      justify-self: end;
      margin-right: 0.125rem;
      margin-left: auto;
    `
      : `
      justify-self: center;
      margin: 0 0.5rem;
    `}

  &.active {
    color: ${({ variant }) => (variant === "primary" ? "#2f8de4" : "#fff")};
    background-color: ${({ variant }) =>
      variant === "primary" ? "#f4f4f4" : "#2f8de4"};
  }

  &:disabled {
    color: grey;
    cursor: not-allowed;
    &:hover {
      color: grey !important;
    }
  }

  ${({ size }) =>
    size === 2 &&
    `
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  `}

  span {
    margin-left: 5px !important;
  }
`;
